<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white headerAccrual">
            <div class="startAccrual">
                <div class="calendarHeader">
                    <Calendar class="svgIcon" />
                </div>
                <span class="titleAccrual ml-2">
                    {{ titleModal }}
                    <br>
                    <span class="subtitleAccrual">{{ subTitleModal }}</span>
                </span>
            </div>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body box-body pt-1 px-5 pb-4">
            <p class="titleSection">
                <span v-if="selectedCounterpart.counterpart_type == 'Trabajador'"> Devengar mes trabajado </span>
                <span v-else-if="selectedCounterpart.counterpart_type == 'Internacional'">
                    Devengar facturas extranjeras / invoices
                </span>
                <span v-else-if="selectedCounterpart.counterpart_type == 'Recibo'"> Devengar recibo </span>
                <span v-else>Devengar documentos</span>
            </p>
            <p> Aquí podrás ajustar el mes en que se reflejara el
                <strong>
                    <span v-if="documentType == 'P'">Egreso</span>
                    <span v-if="documentType == 'C'">Ingreso</span>
                </strong> en tu Estado de Resultados
            </p>
            <div class="mt-3 pt-4">
                <table class="tableAccrual is-striped is-fullwidth is-bordered ">
                    <colgroup>
                        <col v-if="!['Trabajador', 'Internacional', 'Recibo'].includes(selectedCounterpart.counterpart_type)"
                            style="width: 10%;">
                        <col style="width: 15%;">
                        <col style="width: 10%;">
                        <col style="width: 15%;">
                        <col style="width: 50%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th v-if="!['Trabajador', 'Internacional', 'Recibo'].includes(selectedCounterpart.counterpart_type)"
                                class="cellHead py-3 px-2" colspan="1">
                                N° Doc.
                            </th>
                            <th class="cellHead py-3 px-2" colspan="1">
                                <span v-if="selectedCounterpart.counterpart_type == 'Trabajador'">Mes Trabajado</span>
                                <span v-else>Fecha de Emisión</span>

                            </th>
                            <th class="cellHead py-3 px-2" colspan="1">Monto (CLP)</th>
                            <th class="cellHead py-3 px-2" colspan="1">Cuenta</th>
                            <th class="cellHead py-3 px-2" colspan="1">Mes Devengo</th>
                        </tr>
                    </thead>
                    <tbody v-if="localDocuments.length == rangeStartDates.length">
                        <tr v-for="(localDocument) in localDocuments" :key="localDocument.order_pos">
                            <td v-if="!['Trabajador', 'Internacional', 'Recibo'].includes(selectedCounterpart.counterpart_type)"
                                class="py-4 px-2 maxColumnWidth" :title="localDocument.doc_number">
                                {{ localDocument.doc_number }}
                            </td>
                            <td class="py-4 px-2 is-capitalized">
                                <span v-if="selectedCounterpart.counterpart_type == 'Trabajador'">
                                    {{ getFormattedDate(localDocument.emitted_at, 'MMM-YYYY').replace('.', '') }}
                                </span>
                                <span v-else> {{ getFormattedDate(localDocument.emitted_at) }} </span>
                            </td>
                            <td class="py-4 px-2">
                                {{ money(localDocument.amount * localDocument.selectedAccount.percentage / 100) }}
                            </td>
                            <td class="py-4 px-2 is-capitalized">
                                {{ localDocument.selectedAccount.level_3 }}
                            </td>
                            <td class="py-1">
                                <div class="accrualMonth">
                                    <AnualCalendar class="calendar" v-model="rangeStartDates[localDocument.order_pos]"
                                        :theme="'classification_theme'"
                                        @date-change="(e) => changeDate(localDocument.order_pos, 'start')" />
                                    <AnualCalendar class="calendar" :disabled="!divideMonths"
                                        v-model="rangeEndDates[localDocument.order_pos]"
                                        :theme="getThemeEndDates(localDocument.order_pos)" :disableOldDates="true"
                                        :disabledFrom="rangeStartDates[localDocument.order_pos]"
                                        @date-change="(e) => changeDate(localDocument.order_pos)" />

                                    <div v-if="localDocument.has_accrual" class="ml-4 py-3 is-flex is-clickable"
                                        style="gap: 0px;"
                                        @click="openConfirmRestoreModal(localDocument.td_id, localDocument.selectedAccount)">
                                        <FlipBackward class="mt-0" style="flex: 1;" />
                                        <p class="restore " style="flex: 1;">Deshacer</p>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="mt-5 checkboxes is-clickable">
                <label for="divideMonths" class="">
                    <input class="accent-green" type="checkbox" v-model="divideMonths" name="divideMonths"
                        id="divideMonths">
                    <span class="ml-2">Dividir en varios meses</span>
                </label>
                <div>
                    <span v-if="showMsgSuccess" class="is-pulled-right msg-success-save-tree">
                        <Tick class="icon mr-2" />
                        Devengo configurado con éxito
                        <Ecs class="icon close-icon" @click="() => showMsgSuccess = false" />
                    </span>
                </div>
            </div>

            <div v-if="getAccrualsToUpdate.length > 0" class="containerMsg accrualSuccess">
                <p class="text">Se devengará:
                <ul>
                    <li v-for="doc in getAccrualsToUpdate" v-bind:key="doc.order_pos">
                        <span v-if="selectedCounterpart.counterpart_type == 'Trabajador'">
                            El mes trabajado
                        </span>
                        <span v-else-if="selectedCounterpart.counterpart_type == 'Internacional'">
                            La factura extranjera
                        </span>
                        <span v-else-if="selectedCounterpart.counterpart_type == 'Recibo'">
                            El recibo
                        </span>
                        <span v-else>
                            El documento {{ doc.doc_number }},
                        </span>
                        con cuenta: {{ doc.selectedAccount.level_3 }},
                        <span
                            v-if="divideMonths && rangeStartDates[doc.order_pos].getTime() != rangeEndDates[doc.order_pos].getTime()">
                            de {{ getMonthName(rangeStartDates[doc.order_pos]) }} {{
                                rangeStartDates[doc.order_pos].getFullYear() }} a
                            {{ getMonthName(rangeEndDates[doc.order_pos]) }} {{
                                rangeEndDates[doc.order_pos].getFullYear() }} por
                            <span class="bold">{{ money(calculateAmount(doc.order_pos, doc.selectedAccount)) }}
                                mensual</span>
                        </span>
                        <span
                            v-if="!divideMonths || rangeStartDates[doc.order_pos].getTime() == rangeEndDates[doc.order_pos].getTime()">
                            en el mes de {{ getMonthName(rangeStartDates[doc.order_pos]) }} {{
                                rangeStartDates[doc.order_pos].getFullYear() }}
                            un total de <span class="bold">{{ money(calculateAmount(doc.order_pos, doc.selectedAccount))
                                }}</span>
                        </span>
                    </li>
                </ul>

                </p>
            </div>

            <div v-if="!validateAllDates() && divideMonths" class="containerMsg accrualError">
                <p class="text is-flex is-align-items-stretch">
                    <ExclamationAlert class="" />
                    <span class="ml-2"> La fecha de inicio no puede ser posterior a la fecha de fin. </span>
                </p>
            </div>
        </section>
        <footer class="modal-card-foot has-background-white is-justify-content-flex-end">
            <b-button class="button" @click="$emit('close')" aria-label="Subir archivo" role="button">
                Cancelar
            </b-button>
            <b-button @click="() => addAccrual()" class="button is-primary backColor"
                :disabled="btnConfirmAccrualLoading || getAccrualsToUpdate.length == 0 || (!validateAllDates() && divideMonths)"
                aria-label="Subir archivo" role="button">
                Confirmar Devengo
            </b-button>
        </footer>
    </div>
</template>

<script>
import AnualCalendar from "@/components/classification/AnualCalendar";
import ConfirmRestore from "@/components/modals/ConfirmRestore";
import Calendar from "@/components/svg/Calendar.vue";
import Ecs from "@/components/svg/Ecs";
import ExclamationAlert from "@/components/svg/ExclamationAlert.vue";
import FlipBackward from "@/components/svg/FlipBackward.vue";
import Tick from "@/components/svg/Tick";
import { parseToMoney } from "@/utils/currency";
import moment from "moment";
import { mapActions, mapState } from "vuex";


// import SortButton from "@/components/modals/SortButton.vue";
export default {
    name: "ChangeAccrual",
    components: {
        Calendar,
        AnualCalendar,
        FlipBackward,
        ExclamationAlert,
        Tick,
        Ecs
        // SortButton,
    },
    props: {
        titleModal: {
            type: String,
            required: true,
        },
        subTitleModal: {
            type: String,
            required: true,
        },
        documentType: {
            type: String,
            required: true,
        },
        documents: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            rangeStartDates: [],
            rangeEndDates: [],
            divideMonths: false,
            btnConfirmAccrualLoading: false,
            localDocuments: [],
            modalDefault: {
                parent: this,
                width: "25%",
                hasModalCard: true,
                canCancel: ["escape", 'button', "outside"],
                customClass: "center-always-modal",
            },
            allInitialAccrual: [],
            showMsgSuccess: false
        };
    },
    computed: {
        ...mapState("classification", ["selectedCounterpart"]),
        getAccrualsToUpdate() {
            return this.localDocuments.filter(doc => doc.has_edited_accrual)
        }

    },
    methods: {
        ...mapActions("classification", [
            "fetchDevengoBatch",
            "saveDevengo",
            "deleteDevengoByDocId",
        ]),
        addAccrual() {
            this.btnConfirmAccrualLoading = true
            const plan_accounts_ids = this.getAccrualsToUpdate.map(doc => {
                return doc.selectedAccount.account_plan_id

            })
            let body = {
                docs_ids: this.getAccrualsToUpdate.map(doc => doc.td_id),
                plan_accounts_ids: plan_accounts_ids
            }
            if (this.divideMonths) {
                body = {
                    ...body,
                    start_dates: this.getAccrualsToUpdate.map(doc => this.rangeStartDates[doc.order_pos]),
                    end_dates: this.getAccrualsToUpdate.map(doc => this.rangeEndDates[doc.order_pos]),
                }
            } else {
                body = {
                    ...body,
                    start_dates: this.getAccrualsToUpdate.map(doc => this.rangeStartDates[doc.order_pos]),
                    end_dates: this.getAccrualsToUpdate.map(doc => this.rangeStartDates[doc.order_pos]),
                }
            }
            //save accrual here
            const docs = [...this.localDocuments]
            this.localDocuments = []
            this.saveDevengo(body).then((data) => {
                this.showMsgSuccess = true
                this.localDocuments = docs.map(doc => {
                    if (data.includes(doc.td_id) && plan_accounts_ids.includes(doc.selectedAccount.account_plan_id)) {
                        doc.has_accrual = true
                        doc.has_edited_accrual = false
                    }
                    return doc
                })
                setTimeout(() => {
                    this.showMsgSuccess = false
                }, 2000);
                this.$emit('save_accrual', body)
            }).finally(() => {
                this.btnConfirmAccrualLoading = false
            })
        },
        changeDate(iDoc, type) {
            if (this.allInitialAccrual[iDoc][0].getTime() != this.rangeStartDates[iDoc].getTime() ||
                this.allInitialAccrual[iDoc][1].getTime() != this.rangeEndDates[iDoc].getTime()) {
                this.localDocuments[iDoc].has_edited_accrual = true
            } else {
                this.localDocuments[iDoc].has_edited_accrual = false
            }

            if (type == 'start') {
                this.rangeEndDates[iDoc] = this.rangeStartDates[iDoc]
            }
            this.localDocuments = [...this.localDocuments]

        },
        money(value) {
            return parseToMoney(value);
        },
        calculateAmount(posDocument, selectedAccount) {
            const months = this.monthDiff(this.rangeStartDates[posDocument], this.rangeEndDates[posDocument])
            if (months == 0) {
                return 0
            }
            const amountDoc = this.localDocuments[posDocument].amount / months
            return amountDoc * selectedAccount.percentage / 100
        },
        validateAllDates() {
            let allValid = true
            this.rangeStartDates.map((date, iDate) => {
                if (date.getTime() > this.rangeEndDates[iDate].getTime()) {
                    allValid = false
                }
            })
            return allValid
        },
        getThemeEndDates(posDocument) {
            if (this.rangeStartDates[posDocument].getTime() > this.rangeEndDates[posDocument].getTime() && this.divideMonths) {
                return 'alert_theme'
            }
            return 'classification_theme'
        },
        monthDiff(d1, d2) {
            if (!this.divideMonths) {
                return 1
            }
            let months = 0;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            if (months < 0) {
                return 0
            } else if (months == 0) {
                return 1
            }
            return months + 1 //incluyendo mes final
        },
        openConfirmRestoreModal(idDoc, accountPlan) {
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ConfirmRestore,
                props: {
                    eventNameConfirmRestore: 'restoreAccrual',
                    tittleRestore: '¿Desea deshacer este devengo?',
                    subTittleRestore: 'Esta acción revertirá todos los cambios realizados y los datos regresarán a su estado original en la fecha de emisión.',
                    msgOkAction: 'Deshacer Devengo'
                },
                events: {
                    restoreAccrual: () => {
                        this.deleteAccrual(idDoc, accountPlan.account_plan_id)
                    }
                },
            });
        },
        deleteAccrual(docId, accountPlanId) {
            let localDocuments = [...this.localDocuments]
            this.deleteDevengoByDocId({ docId, accountPlanId }).then(() => {
                let isMonthDivided = false
                localDocuments = localDocuments.map((doc, iDoc) => {
                    if (doc.td_id == docId && doc.selectedAccount.account_plan_id == accountPlanId) {
                        doc.has_accrual = false
                        const firstDate = this.initDateFirstDayMonthByStr(doc.emitted_at)
                        this.rangeStartDates[iDoc] = firstDate
                        this.rangeEndDates[iDoc] = firstDate
                    }
                    if (this.rangeStartDates[iDoc].getTime() != this.rangeEndDates[iDoc].getTime()) {
                        isMonthDivided = true
                    }
                    return doc
                })
                this.divideMonths = isMonthDivided
                this.localDocuments = [...localDocuments]
            })
        },
        initDateFirstDayMonthByStr(emittedDate) {
            const stuckTime = 'T00:00:00'
            let date = new Date(emittedDate + stuckTime)
            return new Date(date.getFullYear(), date.getMonth(), 1)
        },
        initDateByStr(emittedDate) {
            const stuckTime = 'T00:00:00'
            let date = new Date(emittedDate + stuckTime)
            return new Date(date.getFullYear(), date.getMonth(), date.getDate())
        },
        getFormattedDate(emittedDate, format = 'DD-MM-YYYY') {
            const date = this.initDateByStr(emittedDate)
            return moment(date).format(format);
        },
        getMonthName(date) {
            return moment(date).format('MMMM');
        }

    },
    async mounted() {
        // Un solo request batch para todos los pares (doc × cuenta): colapsa el
        // N+1 anterior. Como ahora iteramos en orden (sin Promise.all anidado),
        // order_pos queda determinístico (antes dependía del orden de resolución).
        const pairs = []
        this.documents.forEach((doc) => {
            doc.accounts.forEach((account) => {
                pairs.push({ docId: doc.td_id, accountPlanId: account.account_plan_id })
            })
        })
        const ranges = await this.fetchDevengoBatch({
            docsIds: pairs.map((pair) => pair.docId),
            planAccountsIds: pairs.map((pair) => pair.accountPlanId),
        })

        let posDoc = 0
        let listDocs = []
        this.documents.forEach((doc) => {
            doc.accounts.forEach((account) => {
                const data = ranges[`${doc.td_id}_${account.account_plan_id}`] || []
                let docAccount = JSON.parse(JSON.stringify(doc))

                let initialAccrual = []
                if (data.length == 0) {
                    const firstDate = this.initDateFirstDayMonthByStr(doc.emitted_at)
                    this.rangeStartDates.push(firstDate)
                    this.rangeEndDates.push(firstDate)
                    docAccount.has_accrual = false
                    initialAccrual = [firstDate, firstDate]
                } else if (data.length == 1) {
                    const firstDate = this.initDateFirstDayMonthByStr(data[0].month_year)
                    this.rangeStartDates.push(firstDate)
                    this.rangeEndDates.push(firstDate)
                    docAccount.has_accrual = true
                    initialAccrual = [firstDate, firstDate]
                } else {
                    const firstDate = this.initDateFirstDayMonthByStr(data[0].month_year)
                    const lastDate = this.initDateFirstDayMonthByStr(data[1].month_year)
                    this.rangeStartDates.push(firstDate)
                    this.rangeEndDates.push(lastDate)
                    docAccount.has_accrual = true
                    this.divideMonths = true
                    initialAccrual = [firstDate, lastDate]
                }
                docAccount.has_edited_accrual = false
                docAccount.order_pos = posDoc
                docAccount.selectedAccount = account
                posDoc++
                this.allInitialAccrual.push(initialAccrual)
                listDocs.push(docAccount)
            })
        })
        this.localDocuments = [...listDocs]
    },

};
</script>
<style lang="scss" scoped>
* {
    font-family: Inter;
}

.modal-card {
    overflow: visible;
    z-index: 10;
    margin: auto !important;
    justify-content: center;
}

.headerAccrual {
    display: flex;
    border-bottom: none;

    .startAccrual {
        display: flex;

        .calendarHeader {
            width: 48px;
            height: 48px;
            padding: 14px;
            justify-content: center;
            align-items: center;
            border-radius: 24px;
            background: #DCFAE6;

            .svgIcon {
                filter: invert(36%) sepia(48%) saturate(5838%) hue-rotate(140deg) brightness(93%) contrast(94%);
            }
        }

        .titleAccrual {
            flex: 1;
            color: #101828;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            text-transform: uppercase;

            .subtitleAccrual {
                color: #475467;
                font-weight: 400;
            }
        }
    }

    .delete {
        margin-left: auto;
    }

}

.msg-success-save-tree {
    padding: 8px;
    border-radius: 12px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: #ECFDF3;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    color: #079455;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;

    .icon {
        margin-bottom: -5px;
    }

    .close-icon {
        height: 20px;
        width: 20px;
        filter: brightness(0) saturate(100%) invert(65%) sepia(6%) saturate(705%) hue-rotate(179deg) brightness(98%) contrast(93%);
    }
}

.titleSection {
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
}

.modal-card-body {
    overflow: visible;
    z-index: 10;
}

.tableAccrual {
    border-collapse: collapse;
    border-radius: 8px;
    border-style: hidden;
    box-shadow: 0 0 0 1px #EAECF0;
    table-layout: fixed;
    width: 100%;

    td,
    .cellHead {
        border: none;
        padding: auto !important;
    }

    thead {
        background-color: #EAECF0;

        th {
            font-size: 12px;
            font-weight: 500;
            line-height: 18px;
            text-align: left;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;
            color: #475467;
        }
    }

    tbody {
        td {
            font-size: 12px;
            font-weight: 500;
            line-height: 20px;
            text-align: left;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;
            color: #475467;
        }
    }

    .maxColumnWidth {
        max-width: 120px;
        overflow: hidden;

        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
        /* Muestra que hay más información */
    }
}

.checkboxes {
    label {
        display: inline-block;
        padding-right: 10px;
        white-space: nowrap;

        span {
            user-select: none;
        }

        .accent-green {
            appearance: none;
            width: 16px;
            height: 16px;
            color: black;
            background-color: white;
            border: 1px solid black;
            border-radius: 4px;
        }

        .accent-green:checked {
            border: none;
        }

        .accent-green::before {
            content: "✔";
            color: white;
            font-size: 14px;
            display: none;
            border-radius: 4px;
            background-color: #00A9AD;
            border: none;
            width: 16px;
            height: 16px;
            text-align: center;
        }

        .accent-green:checked::before {
            display: block;

        }
    }
}

.backColor {
    background-color: #00A9AD;
    border: 1px solid #00A9AD;
    box-shadow: 0px 1px 2px 0px #1018280D;
}

.accrualMonth {
    display: flex;

    .calendar {
        max-width: 30%;
        flex: 1;
        margin-inline-start: 8px;
    }

    .restore {
        color: #101828;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        margin-top: 1px;
    }
}

.containerMsg {
    margin-top: 24px;
    padding: 12px;
}

.accrualSuccess {
    border-radius: 8px;
    border: 1px solid #75E0A7;

    background: #ECFDF3;

    /* Shadows/shadow-xs */
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    .text {
        color: #079455;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;

        margin-top: -2px;

        ul {
            margin-left: 20px;
            list-style: disc;
        }

        .bold {
            font-weight: 600;
        }
    }
}

.accrualError {
    border-radius: 8px;
    border: 1px solid #FEC84B;
    background: #FFFAEB;

    /* Shadows/shadow-xs */
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    .text {
        color: #4E1D09;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
    }
}
</style>